$( document ).ready(function() {
  $('.match_att h2:first-child').click ();

  $('.match_att h2').click(function () {
    $(this).addClass('active_slider').siblings().removeClass('active_slider');
    var id = $(this).attr('attr');
    $('.each_function_here .cards_how_it_wprks').each(function () {
      var sec = $(this).attr('new');
      if (sec==id) {
        $(this).show();
      }else{
        $(this).hide();
      }
    })
  })
})
if (window.matchMedia("(max-width: 700px)").matches) {
    $('.before-after-flex').slick({
      dots: true,
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    })
} 


  $('.main_Slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      asNavFor: '.products_thumnails_slider'
    })
    
  $('.products_thumnails_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main_Slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    variableWidth: true,
    prevArrow: '<button class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M12.2996 16.4629L13.3496 15.3941L6.91836 8.96289L13.3496 2.53164L12.2996 1.46289L4.79961 8.96289L12.2996 16.4629Z" fill="#060606"/></svg></button>',
    nextArrow: '<button class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M5.70039 16.4629L4.65039 15.3941L11.0816 8.96289L4.65039 2.53164L5.70039 1.46289L13.2004 8.96289L5.70039 16.4629Z" fill="#060606"/></svg></button>'

  });

$('.readm').click(function () {
  $('.product-short-description').toggleClass("active");
  $(this).html() == "read less" ? $(this).html('read more') : $(this).html('read less');
});




// document.addEventListener("DOMContentLoaded", function () {
//   const wrapper = document.querySelector(".mobile-toggle-wrapper");
//   const toggle = document.querySelector(".mobile-toggle");

//   if (wrapper && toggle) {
//     // Wrapper par click karne par
//     wrapper.addEventListener("click", function (e) {
//       // Agar click summary par nahi hua (wrapper par directly hua)
//       if (e.target === wrapper || (!e.target.closest('.mobile-toggle'))) {
//         // Summary ko programmatically toggle karo
//         toggle.click();
//       }
//     });
//   }
// });